// Meetings shorter than this are treated as noise and are excluded from both
// the Timeline and Meeting Insights reports so their numbers stay consistent.
export const minMeetingSeconds = 5 * 60;

export function excludeShortMeetings<T extends { time?: number }>(meetings: T[]): T[] {
  return (meetings || []).filter(meeting => (meeting?.time || 0) >= minMeetingSeconds);
}
